import axios from 'axios';
import useAlert from '@global/composable/useAlert';
import createApi from './apiCalls'; // 引入 createApi 函數

const { alertDialog } = useAlert();

// 201 無剩餘的購物金，無法進行結清
// 205 商品已售完 / 贈品被移除 (因贈品不能寄海外)
// 206 贈品庫存異動
// 400 特定錯誤訊息
// 401 尚未登入
// 403 系統忙線中
// 500 URL: 此E-mail已綁定第三方登入帳號

const successHandle = (res, handleDefaultError, handle401, handle500) => {
  switch (res.data.Code) {
    case 200:
    case 201:
    case 205:
    case 206:
      break;
    case 400:
      alertDialog.alert(res.data.Message);
      break;
    case 401:
      if (!handle401) {
        alertDialog.alert('請先登入');
      } else {
        alertDialog.alert('我要登入/註冊', () => {
          window.location.href = `/login?redirecturl=${handle401}`;
        });
      }
      break;
    case 403:
      alertDialog.confirm('系統忙線中，是否跳轉至首頁', () => {
        window.location.href = '/';
      });
      break;
    case 500:
      if (!handle500) {
        alertDialog.confirm('系統忙線中，是否跳轉至首頁', () => {
          window.location.href = '/';
        });
      }
      break;
    default:
      if (!handleDefaultError) {
        alertDialog.confirm('系統忙線中，是否跳轉至首頁', () => {
          window.location.href = '/';
        });
      }
      break;
  }
};

const errorHandle = () => {
  alertDialog.confirm('系統忙線中，是否跳轉至首頁', () => {
    window.location.href = '/';
  });
};

const instance = axios.create({
  baseURL: '',
});

// request 攔截
instance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// response 攔截
instance.interceptors.response.use(
  (res) => {
    const { handleDefaultError } = res.config.headers;
    const { handle401, handle500 } = res.config.headers;
    successHandle(res, handleDefaultError, handle401, handle500);
    // 這邊可以對回來的資料先進行驗證處理，再來決定要不要把資料給吐出去
    return Promise.resolve(res);
  },
  (error) => {
    errorHandle();
    return Promise.reject(error);
  },
);

// 使用 createApi 函數生成 API 調用函數
const api = createApi(instance);

function useAPIHandler() {
  return api;
}

export default useAPIHandler;
